import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { FormComponent, FormsComponent } from '../interfaces';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnsavedChangesDialog } from '../components/dialogs/unsaved-changes-dialog/unsaved-changes-dialog';
import { ProgressService } from '../services/progress.service';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<FormComponent|FormsComponent> {

    constructor(
        private unsavedChangesService: UnsavedChangesService
    ) {}

    canDeactivate(component: FormComponent|FormsComponent) {
        if ('form' in component) {
            if (component['form'].dirty) {
                return this.unsavedChangesService.openDialog(true);
            }
        } else if ('forms' in component) {
            let hasDirtyForm = false;
            for (let form of component['forms']) {
                if (form && form.dirty) {
                    hasDirtyForm = true;
                    break;
                }
            }
            if (hasDirtyForm) {
                return this.unsavedChangesService.openDialog(true);
            }
        }
        return true;
    }
}